import { Trans } from '@lingui/react/macro';
import {
  type FacilityTransferItemPublicRecord,
  type FacilityTransferRoundPublicRecord,
  FacilityTransferDirection
} from '@navio/nsdk';
import { NoddiIcon } from 'noddi-ui-common';
import { useState } from 'react';
import { PickupRoundGroups } from './PickupRoundGroups';

interface Props {
  title: string;
  items: FacilityTransferItemPublicRecord[];
  rounds: FacilityTransferRoundPublicRecord[];
  // Finished wheel sets need no attention, so their section starts folded away.
  isCollapsible: boolean;
  // Searching or filtering must never hide a match behind a closed section.
  isForcedOpen: boolean;
}

export const StatusSection = ({ title, items, rounds, isCollapsible, isForcedOpen }: Props) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const showToggle = isCollapsible && !isForcedOpen;
  const showItems = !showToggle || isExpanded;
  const heading = `${title} (${items.length})`;

  return (
    <section className='flex flex-col gap-2'>
      {showToggle ? (
        <button
          type='button'
          aria-expanded={isExpanded}
          onClick={() => setIsExpanded((prev) => !prev)}
          className='flex w-full items-center justify-between gap-2 rounded-lg border border-gray-200 bg-white/60 px-4 py-3 text-left text-sm'
        >
          <span className='flex items-center gap-2 font-semibold'>
            <NoddiIcon name='CheckCircle' size='small' className='text-successDark' />
            {heading}
          </span>
          <span className='flex items-center gap-1 text-muted-foreground'>
            {isExpanded ? <Trans>Hide</Trans> : <Trans>Show</Trans>}
            <NoddiIcon name={isExpanded ? 'ChevronUp' : 'ChevronDown'} size='small' />
          </span>
        </button>
      ) : (
        <h2 className='text-sm font-semibold'>{heading}</h2>
      )}
      {showItems && <PickupRoundGroups items={items} rounds={rounds} direction={FacilityTransferDirection.OUTGOING} />}
    </section>
  );
};
